import { render, staticRenderFns } from "./TextView.vue?vue&type=template&id=59691b32&scoped=true"
import script from "./TextView.vue?vue&type=script&lang=js"
export * from "./TextView.vue?vue&type=script&lang=js"
import style0 from "./TextView.vue?vue&type=style&index=0&id=59691b32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59691b32",
  null
  
)

export default component.exports